<template>
<v-card>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-text-field outlined hide-details v-model="category.label" label="Label"></v-text-field>
      </v-col>
      <v-col cols="12" md="6" v-for="(rank,c) in category.goals" :key="c">
        <v-container>
          <v-row class="py-0" align="center">
            <v-col cols="6" class="py-0">
              <h3>Rank {{c+1}}</h3>
            </v-col>
            <v-col cols="6" class="text-right py-0">
              <span :class="`rank-star rank-${c+1}-star`"><v-icon large>fa-star</v-icon></span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field prepend-icon="far fa-square" label="Goal 1" v-model="rank[0]" hide-details></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field prepend-icon="far fa-square" label="Goal 2" v-model="rank[1]" hide-details></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</v-card>
</template>
<script>
/*
<v-card-title class="secondary white--text">
  <span class="" v-if="edit_title">
    <v-text-field outlined hide-details dark :label="i" v-model="category.label" append-icon="fa-check" @click:append="edit_title=false"></v-text-field>
  </span>

  <span class="clicky" v-else @click="edit_title=true">{{category.label}}</span>
  <v-spacer></v-spacer>
  <v-btn icon dark @click="show = !show">
    <v-icon v-if="show">fa-minus</v-icon>
    <v-icon v-else>fa-chevron-down</v-icon>
  </v-btn>
</v-card-title>

*/
export default {
  name: "",
  props: ['value'],
  data: () => ({
    show: false,
    edit_title: false,
  }),
  computed: {
    category() {
      return this.value
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
